import { useLocalStorage } from '../useLocalStorage.hook';

export const useFullCalendarLocalStorage = (calendarId: string) => {
  const helpers = useLocalStorage<Date>(`${calendarId}_date`);

  return helpers;
};